import React from 'react';

import { Header } from 'components';
import { RoutesInterface } from 'types/interfaces';
import styles from './BaseLayout.module.scss';

const BaseLayoutWithoutSidenav = (props: RoutesInterface): JSX.Element | null => {
  const { component: Component } = props;

  return (
    <>
      <Header />
      <div className={styles.root}>
        <main role="main" className={styles.main}>
          {Component ? <Component {...props} /> : null}
        </main>
      </div>
    </>
  );
};
export default BaseLayoutWithoutSidenav;
